import React, { useCallback } from "react";
import xlsx from "node-xlsx";
import { useDropzone } from "react-dropzone";

export function StepUpload({ setFile }) {
  const onDrop = useCallback((files) => {
    let reader = new FileReader();
    let file = files[0];
    let mapping = undefined;
    try {
      mapping = JSON.parse(window.localStorage.importMapping);
    } catch (e) {}
    reader.onload = (e) => {
      setFile({
        name: file.name,
        data: xlsx.parse(e.target.result),
        step: "mapping",
        mapping: mapping,
      });
    };
    reader.readAsArrayBuffer(file);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
  });
  return (
    <div className={"flex flex-col gap-3"}>
      <h1 className={"font-bold"}>Importing bank transactions</h1>
      <p>
        To import bank transactions, drop below a CSV or XLS file from your bank
        with all the bank transactions during a given period.
      </p>
      <div
        {...getRootProps()}
        className={
          "border border-gray-400 p-3 rounded border-dashed bg-white hover:bg-blue-50 cursor-pointer"
        }
      >
        <input {...getInputProps()} />
        {isDragActive ? <p>Drop a file</p> : <p>Drop a file</p>}
      </div>
    </div>
  );
}
